import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDisplayStore } from '../context/DisplayStoreProvider'
import { DEFAULT_TRADE_PATH, useWalletAuth } from '../context/WalletAuthProvider'

export default function Connect() {
  const location = useLocation()
  const navigate = useNavigate()
  const { openConnectModal } = useDisplayStore()
  const { isConnected, isAuthenticated } = useWalletAuth()
  const returnPath = location.state?.returnPath || DEFAULT_TRADE_PATH

  useEffect(() => {
    if (isConnected && isAuthenticated) {
      navigate(returnPath, { replace: true })
      return
    }
    openConnectModal()
  }, [isConnected, isAuthenticated, navigate, openConnectModal, returnPath])

  return null
}
